var map = {
	"./32/Abkhazia.png": "ce9d",
	"./32/Afghanistan.png": "43ab",
	"./32/Aland.png": "a5c7",
	"./32/Albania.png": "4b0c",
	"./32/Algeria.png": "f9db",
	"./32/American-Samoa.png": "63de",
	"./32/Andorra.png": "ef5b",
	"./32/Angola.png": "6932",
	"./32/Anguilla.png": "d410",
	"./32/Antarctica.png": "7d30",
	"./32/Antigua-and-Barbuda.png": "5ebe",
	"./32/Argentina.png": "067d",
	"./32/Armenia.png": "895d",
	"./32/Aruba.png": "eda9",
	"./32/Australia.png": "7454",
	"./32/Austria.png": "4a8d",
	"./32/Azerbaijan.png": "9d7e",
	"./32/Bahamas.png": "b2b5",
	"./32/Bahrain.png": "882c",
	"./32/Bangladesh.png": "15d3",
	"./32/Barbados.png": "f9fc",
	"./32/Belarus.png": "2f5e",
	"./32/Belgium.png": "2bcd",
	"./32/Belize.png": "c54b",
	"./32/Benin.png": "ae932",
	"./32/Bermuda.png": "459e",
	"./32/Bhutan.png": "b15c",
	"./32/Bolivia.png": "3632",
	"./32/Bosnia-and-Herzegovina.png": "1f85",
	"./32/Botswana.png": "e76c",
	"./32/Brazil.png": "107a",
	"./32/British-Antarctic-Territory.png": "68f6",
	"./32/British-Virgin-Islands.png": "fe92",
	"./32/Brunei.png": "758e",
	"./32/Bulgaria.png": "fa44",
	"./32/Burkina-Faso.png": "47b4",
	"./32/Burundi.png": "ff86",
	"./32/Cambodia.png": "c351",
	"./32/Cameroon.png": "d3f7",
	"./32/Canada.png": "70a9",
	"./32/Cape-Verde.png": "27a9",
	"./32/Cayman-Islands.png": "c071",
	"./32/Central-African-Republic.png": "aae0",
	"./32/Chad.png": "7b3f",
	"./32/Chile.png": "e09f",
	"./32/China.png": "a434",
	"./32/Christmas-Island.png": "d895",
	"./32/Cocos-Keeling-Islands.png": "0bbe",
	"./32/Colombia.png": "3dba",
	"./32/Commonwealth.png": "c003",
	"./32/Comoros.png": "636e",
	"./32/Cook-Islands.png": "637c",
	"./32/Costa-Rica.png": "d2de",
	"./32/Cote-d'Ivoire.png": "d8955",
	"./32/Croatia.png": "0d16",
	"./32/Cuba.png": "a77a",
	"./32/Cyprus.png": "b471",
	"./32/Czech-Republic.png": "298b",
	"./32/Democratic-Republic-of-the-Congo.png": "8c8b",
	"./32/Denmark.png": "a5cb",
	"./32/Djibouti.png": "ca31",
	"./32/Dominica.png": "5140",
	"./32/Dominican-Republic.png": "2eed",
	"./32/East-Timor.png": "7273",
	"./32/Ecuador.png": "b178",
	"./32/Egypt.png": "89b7",
	"./32/El-Salvador.png": "ee69",
	"./32/England.png": "5c8a",
	"./32/Equatorial-Guinea.png": "3e5b",
	"./32/Eritrea.png": "db3d",
	"./32/Estonia.png": "e5b7",
	"./32/Ethiopia.png": "bb3a",
	"./32/European-Union.png": "9d29",
	"./32/Falkland-Islands.png": "cc1c",
	"./32/Faroes.png": "f344",
	"./32/Fiji.png": "daaa",
	"./32/Finland.png": "53c7",
	"./32/France.png": "ae0a",
	"./32/Gabon.png": "1211",
	"./32/Gambia.png": "307f",
	"./32/Georgia.png": "0af1",
	"./32/Germany.png": "8e67",
	"./32/Ghana.png": "3fff",
	"./32/Gibraltar.png": "9744",
	"./32/GoSquared.png": "d4ea",
	"./32/Greece.png": "f5eb",
	"./32/Greenland.png": "715d",
	"./32/Grenada.png": "f352",
	"./32/Guam.png": "19c5",
	"./32/Guatemala.png": "eb7c",
	"./32/Guernsey.png": "05c9",
	"./32/Guinea-Bissau.png": "64ae",
	"./32/Guinea.png": "a28b",
	"./32/Guyana.png": "784a",
	"./32/Haiti.png": "4d6c",
	"./32/Honduras.png": "ff92",
	"./32/Hong-Kong.png": "9fc0",
	"./32/Hungary.png": "458e",
	"./32/Iceland.png": "db71",
	"./32/India.png": "cc6b",
	"./32/Indonesia.png": "dbb7",
	"./32/Iran.png": "5006",
	"./32/Iraq.png": "c250",
	"./32/Ireland.png": "14df",
	"./32/Isle-of-Man.png": "9166",
	"./32/Israel.png": "d1b5",
	"./32/Italy.png": "d632",
	"./32/Jamaica.png": "91ee",
	"./32/Japan.png": "4263",
	"./32/Jersey.png": "ceb6",
	"./32/Jordan.png": "7803",
	"./32/Kazakhstan.png": "1ab9",
	"./32/Kenya.png": "bba4",
	"./32/Kiribati.png": "8125",
	"./32/Kosovo.png": "99da",
	"./32/Kuwait.png": "bb3b",
	"./32/Kyrgyzstan.png": "8165",
	"./32/Laos.png": "7197",
	"./32/Latvia.png": "ff01",
	"./32/Lebanon.png": "c466",
	"./32/Lesotho.png": "a19b",
	"./32/Liberia.png": "0675",
	"./32/Libya.png": "2304",
	"./32/Liechtenstein.png": "3218",
	"./32/Lithuania.png": "aad5",
	"./32/Luxembourg.png": "d71a",
	"./32/Macau.png": "848e",
	"./32/Macedonia.png": "d1a5",
	"./32/Madagascar.png": "753c",
	"./32/Malawi.png": "b635",
	"./32/Malaysia.png": "ffc4",
	"./32/Maldives.png": "c9b0",
	"./32/Mali.png": "7ee3",
	"./32/Malta.png": "774c",
	"./32/Mars.png": "ccfe",
	"./32/Marshall-Islands.png": "2172",
	"./32/Mauritania.png": "ffe1",
	"./32/Mauritius.png": "426f",
	"./32/Mayotte.png": "6a2a",
	"./32/Mexico.png": "6e81",
	"./32/Micronesia.png": "fb95",
	"./32/Moldova.png": "68e2",
	"./32/Monaco.png": "41ce",
	"./32/Mongolia.png": "e1f6",
	"./32/Montenegro.png": "ac69",
	"./32/Montserrat.png": "7fac",
	"./32/Morocco.png": "6f5b",
	"./32/Mozambique.png": "e7db",
	"./32/Myanmar.png": "b3af",
	"./32/NATO.png": "ebfd",
	"./32/Nagorno-Karabakh.png": "e96d",
	"./32/Namibia.png": "18b6",
	"./32/Nauru.png": "0e11",
	"./32/Nepal.png": "f6e0",
	"./32/Netherlands-Antilles.png": "f75e",
	"./32/Netherlands.png": "5ade",
	"./32/New-Caledonia.png": "f486",
	"./32/New-Zealand.png": "ca5a",
	"./32/Nicaragua.png": "1c45",
	"./32/Niger.png": "346d",
	"./32/Nigeria.png": "22e3",
	"./32/Niue.png": "4ded",
	"./32/Norfolk-Island.png": "3682",
	"./32/North-Korea.png": "5f53",
	"./32/Northern-Cyprus.png": "c2a8",
	"./32/Northern-Mariana-Islands.png": "1e05",
	"./32/Norway.png": "758ee",
	"./32/Olympics.png": "0b62",
	"./32/Oman.png": "6478",
	"./32/Pakistan.png": "8cb7",
	"./32/Palau.png": "b113",
	"./32/Palestine.png": "c039",
	"./32/Panama.png": "097a",
	"./32/Papua-New-Guinea.png": "202d",
	"./32/Paraguay.png": "8674",
	"./32/Peru.png": "3118",
	"./32/Philippines.png": "a71c",
	"./32/Pitcairn-Islands.png": "0369",
	"./32/Poland.png": "90d3",
	"./32/Portugal.png": "ac3d",
	"./32/Puerto-Rico.png": "2475",
	"./32/Qatar.png": "b5d2",
	"./32/Red-Cross.png": "3248",
	"./32/Republic-of-the-Congo.png": "fa27",
	"./32/Romania.png": "e14f",
	"./32/Russia.png": "6fd8",
	"./32/Rwanda.png": "58c0",
	"./32/Saint-Barthelemy.png": "39bb",
	"./32/Saint-Helena.png": "d4fd",
	"./32/Saint-Kitts-and-Nevis.png": "4ecb",
	"./32/Saint-Lucia.png": "fa96",
	"./32/Saint-Vincent-and-the-Grenadines.png": "76bc",
	"./32/Samoa.png": "3cbb",
	"./32/San-Marino.png": "c95b",
	"./32/Sao-Tome-and-Principe.png": "04f1",
	"./32/Saudi-Arabia.png": "4a92",
	"./32/Scotland.png": "2e6c",
	"./32/Senegal.png": "aab7",
	"./32/Serbia.png": "21d5",
	"./32/Seychelles.png": "f58e",
	"./32/Sierra-Leone.png": "9070",
	"./32/Singapore.png": "9398",
	"./32/Slovakia.png": "78b4",
	"./32/Slovenia.png": "3578",
	"./32/Solomon-Islands.png": "f842",
	"./32/Somalia.png": "804b",
	"./32/Somaliland.png": "bfdc",
	"./32/South-Africa.png": "d272",
	"./32/South-Georgia-and-the-South-Sandwich-Islands.png": "06c0",
	"./32/South-Korea.png": "6aa7",
	"./32/South-Ossetia.png": "5508",
	"./32/South-Sudan.png": "cd10",
	"./32/Spain.png": "7246",
	"./32/Sri-Lanka.png": "60f4",
	"./32/Sudan.png": "7b66",
	"./32/Suriname.png": "9791",
	"./32/Swaziland.png": "e641",
	"./32/Sweden.png": "4766",
	"./32/Switzerland.png": "a897",
	"./32/Syria.png": "5ca3",
	"./32/Taiwan.png": "1301",
	"./32/Tajikistan.png": "d6af",
	"./32/Tanzania.png": "bce9",
	"./32/Thailand.png": "c7d9",
	"./32/Togo.png": "cf0f",
	"./32/Tonga.png": "1531",
	"./32/Trinidad-and-Tobago.png": "2223",
	"./32/Tunisia.png": "44ef",
	"./32/Turkey.png": "a868",
	"./32/Turkmenistan.png": "2113",
	"./32/Turks-and-Caicos-Islands.png": "2507",
	"./32/Tuvalu.png": "c65c",
	"./32/US-Virgin-Islands.png": "cb29c",
	"./32/Uganda.png": "8a95",
	"./32/Ukraine.png": "d7cb",
	"./32/United-Arab-Emirates.png": "12eb",
	"./32/United-Kingdom.png": "c9c6",
	"./32/United-Nations.png": "78fb",
	"./32/United-States.png": "c217",
	"./32/Uruguay.png": "b2fa",
	"./32/Uzbekistan.png": "7464",
	"./32/Vanuatu.png": "2bd1",
	"./32/Vatican-City.png": "d849",
	"./32/Venezuela.png": "5a06",
	"./32/Vietnam.png": "9367",
	"./32/Wales.png": "6fe71",
	"./32/Western-Sahara.png": "9c9e",
	"./32/Yemen.png": "9fe6",
	"./32/Zambia.png": "8b03",
	"./32/Zimbabwe.png": "21d0",
	"./DE.png": "4749",
	"./EL.png": "8644",
	"./EN.png": "b273",
	"./ES.png": "e7dbd",
	"./FR.png": "773c",
	"./GB.png": "ae65",
	"./PT.png": "615f",
	"./US.png": "7770"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61f4";